import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import PointSelectionTextAbove from './PointSelectionTextAbove';
import PointSelectionTextBelow from './PointSelectionTextBelow';
import PointSelectionDotsAndLines from './PointSelectionDotsAndLines';
import PointSelectionText from './PointSelectionText';

export default function PointSelection(props) {
  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Lato-Regular',
      fontSize: 14,
      fontWeight: 'normal',
    },
  }));

  const classes = useStyles();

  const onSelect = ix => {
    if (props.onSelect) {
      props.onSelect(ix);
    }
  };

  return (
    <div className={classes.root}>
      {/* row with text when part of the text is above */}
      {props.textOnBothSides && props.texts && props.texts.length > 4 && (
        <PointSelectionTextAbove
          firstText={props.texts[1]}
          secondText={props.texts[3]}
        />
      )}

      <PointSelectionDotsAndLines
        color={props.color}
        selectedDot={props.selectedDot}
        onSelect={ix => onSelect(ix)}
        tag={props.tag}
      />

      {!props.textOnBothSides && props.texts && props.texts.length > 4 && (
        <PointSelectionText
          firstText={props.texts[0]}
          secondText={props.texts[1]}
          thirdText={props.texts[2]}
          fourthText={props.texts[3]}
          fifthText={props.texts[4]}
        />
      )}

      {/* row with text when part of the text is below */}
      {props.textOnBothSides && props.texts && props.texts.length > 4 && (
        <PointSelectionTextBelow
          firstText={props.texts[0]}
          secondText={props.texts[2]}
          thirdText={props.texts[4]}
        />
      )}
    </div>
  );
}

PointSelection.propTypes = {
  textOnBothSides: PropTypes.bool,
  texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  colors: PropTypes.string,
  selectedDot: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};
